import { render } from "./FormSettings.vue?vue&type=template&id=f20fb6c6"
import script from "./FormSettings.vue?vue&type=script&lang=js"
export * from "./FormSettings.vue?vue&type=script&lang=js"

import "./FormSettings.vue?vue&type=style&index=0&id=f20fb6c6&lang=scss"
script.render = render

export default script